import { Helmet } from "react-helmet-async"
import { ForbidUnlessAuthorized, PERMISSIONS } from "../../../Auth"
import {
	Breadcrumbs,
	useGetBackUrlFromLocation,
} from "@sembark-travel/ui-router"
import { Box, Container } from "@sembark-travel/ui-base"
import { useNavigate } from "../../../router-utils"
import { MergeSuppliers } from "../../../Supplier"

export default function MergeSuppliersPage() {
	const navigate = useNavigate()
	function navigateToList() {
		return navigate("/suppliers/transport")
	}

	return (
		<ForbidUnlessAuthorized permission={PERMISSIONS.MANAGE_USERS}>
			<Helmet>
				<title>Merge Suppliers</title>
			</Helmet>
			<Breadcrumbs
				title="Suppliers"
				items={[
					[useGetBackUrlFromLocation() ?? "#", "Suppliers"],
					["", "Merge"],
				]}
			/>
			<Box paddingX={{ md: "4" }} paddingY={{ md: "8" }}>
				<Box maxWidth="6xl" marginX="auto">
					<Box borderWidth={{ md: "1" }} rounded="md" bgColor="default">
						<Container paddingY="6">
							<MergeSuppliers
								onSuccess={navigateToList}
								onCancel={navigateToList}
							/>
						</Container>
					</Box>
				</Box>
			</Box>
		</ForbidUnlessAuthorized>
	)
}
